import { lazy, memo, Suspense } from "react";
import { SellerAdminOrganization } from "./pages/admin/SellerAdmin/SellerAdminOrganization/SellerAdminOrganization";
import { PublicIndexWrapper } from "./pages/public";
import { pageForEdition } from "./util/util";
import { Login } from "./pages/Misc/Login";
import { BuyerOrders } from "./pages/Buyer/BuyerOrders";
import { SellerOrdersList } from "./pages/Seller/SellerOrdersList/SellerOrdersList";
import { SellerAdminCustomersList } from "./pages/admin/SellerAdmin/SellerAdminCustomersList/SellerAdminCustomersList";
import { SellerAdminLeadsList } from "./pages/admin/SellerAdmin/SellerAdminLeadsList";
import { SellerAdminLeadDetail } from "./pages/admin/SellerAdmin/SellerAdminLeadDetail";
import { SellerAdminProductDetail } from "./pages/admin/SellerAdmin/SellerAdminProductDetail/SellerAdminProductDetail";
import { ApprovalDetailPage } from "./pages/SharedPages/ProductDetailPage/Approvals/ApprovalDetailPage";
import { SellerAdminCustomerDetail } from "./pages/admin/SellerAdmin/SellerAdminCustomerDetail/SellerAdminCustomerDetail";
import { SellerAdminUserDetail } from "./pages/admin/SellerAdmin/SellerAdminUserDetail";
import {
  LeadsIcon,
  OrderIcon,
  HomeIcon,
  QuoteIcon,
  StackIcon,
  UsersIcon,
  OpportunitiesIcon,
  AnalyticsIcon,
  SoldByIcon,
  LabFlaskIcon,
  CompanyIcon,
  ProductsV2Icon,
  AttributesNavIcon,
  SettingsIcon,
  TemplatesNavIcon,
  ListsIcon,
  AssetsIcon,
  RolesUserIcon,
  PersonalCollectionIcon,
  DistributorsIcon,
  DashboardIcon,
  TeamsIcon,
  ReferenceEntitiesIcon,
  FlagIcon,
} from "./components/Icons/Icons";
import { PageProvider } from "./PageProvider";
import { SellerAdminSettings } from "./pages/admin/SellerAdmin/SellerAdminSettings/SellerAdminSettings";
import { ActivateAccount } from "./pages/Misc/ActivateAccount";
import { UserPreferences } from "./pages/Misc/UserPreferences";
import { ContactUsPage } from "./pages/public/ContactUsPage/ContactUsPage";
import { Registration } from "./pages/public/Registration/Registration";
import { LayoutPortal } from "./layout/LayoutPortal";
import { LayoutPublic } from "./layout/LayoutPublic";
import { BuyerQuotesList } from "./pages/Buyer/BuyerQuotesList";
import { SellerQuotesList } from "./pages/Seller/SellerQuotesList/SellerQuotesList";
import { BuyerQuoteDetail } from "./pages/Buyer/BuyerQuoteDetail/BuyerQuoteDetail";
import { BuyerAdminOrganization } from "./pages/admin/BuyerAdmin/BuyerAdminOrganization/BuyerAdminOrganization";
import { NotSupportedForEdition } from "./pages/Misc/NotSupportedForEdition";
import { SellerQuoteDetail } from "./pages/Seller/SellerQuoteDetail/SellerQuoteDetail";
import { BuyerOrderDetailWrapper } from "./pages/Buyer/BuyerOrderDetail/BuyerOrderDetail";
import { SellerOrderDetail } from "./pages/Seller/SellerOrderDetail/SellerOrderDetail";
import { AllowedRoutes, RedirectPage } from "./util/Routing";
import type { IRoutePaths, RouteType } from "./types/types";
import { Homepage } from "./pages/public/HomePage/HomePage";
import { SetUpCompany } from "./pages/public/SetUpCompany/SetUpCompanyForm";
import { ForgotPassword } from "./pages/public/ForgotPassword/ForgotPassword";
import { ForgotUserName } from "./pages/public/ForgotUserName/ForgotUserName";
import { ResetPassword } from "./pages/Misc/ResetPassword";
import { ProspectsListPage } from "./pages/admin/SellerAdmin/SellerAdminDigitalMarketing/Prospects/ProspectsList";
import { ProspectsListDetails } from "./pages/admin/SellerAdmin/SellerAdminDigitalMarketing/Prospects/ProspectsListDetails";
import { MarketingListPage } from "./pages/admin/SellerAdmin/SellerAdminDigitalMarketing/Marketing/MarketingListPage";
import { CartSwitcherGuest } from "./pages/Misc/CartSwitchers/CartSwitcherGuest";
// import { SellerAdminSampleRequestDetail } from "./pages/admin/SellerAdmin/SellerAdminSampleRequestDetail/SellerAdminSampleRequestDetail";
import { BuyerMyProducts } from "./pages/Buyer/BuyerMyProducts/BuyerMyProducts";
import { BuyerMyProductsPriceTiers } from "./pages/Buyer/BuyerMyProductsPriceTiers/BuyerMyProductsPriceTiers";
import { SellerAdminSampleRequestLeadDetail } from "./pages/admin/SellerAdmin/SellerAdminSampleRequestLeadDetail/SellerAdminSampleRequestLeadDetail";
import { SellerSampleRequests } from "./pages/Seller/SellerSampleRequests/SellerSampleRequests";
import { SellerSampleRequestDetail } from "./pages/Seller/SellerSampleRequestDetail/SellerSampleRequestDetail";
import { CartSwitcherBuyer } from "./pages/Misc/CartSwitchers/CartSwitcherBuyer";
import { BuyerSampleRequests } from "./pages/Buyer/BuyerSampleRequests/BuyerSampleRequests";
import { BuyerSampleRequestDetail } from "./pages/Buyer/BuyerSampleRequestDetail/BuyerSampleRequestDetail";
import { SupportPage } from "./components/SupportPage/SupportPage";
import { LeadDetailPage } from "./pages/SharedPages/LeadsPage/LeadDetailPage";
import { ProductsList } from "./pages/SharedPages/OrganizationPage/ProductsList/ProductsList";
import { CompareProductsPage } from "./pages/SharedPages/OrganizationPage/ProductsList/CompareProducts";
import { BuyerOrganization } from "./pages/Buyer/BuyerOrganization/BuyerOrganization";
//PIM Routes
import { SellerAdminAttributesCollectionDetails } from "./pages/admin/SellerAdmin/PIM/SellerAdminPIMAttributesCollections/SellerAdminAttributesCollectionDetails/SellerAdminAttributesCollectionDetails";
import { AttributeDetailPage } from "./pages/admin/SellerAdmin/PIM/SellerAdminPIMAttributes/AttributeDetailPage";
import { AttributeGroupDetail } from "./pages/admin/SellerAdmin/PIM/SellerAdminPIMAttributeGroups/AttributeGroupDetail";
import { SellerAdminPIMAttributeGroups } from "./pages/admin/SellerAdmin/PIM/SellerAdminPIMAttributeGroups/SellerAdminPIMAttributeGroups";
import { SellerAdminTemplateListingPage } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/SellerAdminTemplateListingPage";
import { SellerAdminAttributesCollectionsList } from "./pages/admin/SellerAdmin/PIM/SellerAdminPIMAttributesCollections/SellerAdminAttributesCollectionsList/SellerAdminAttributesCollectionsList";
import { SellerAdminTemplateGroupDetail } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/SellerAdminTemplateGroupDetail";
import { SellerAdminTemplateCollectionTable } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/SellerAdminTemplateCollectionTable";
import { SellerAdminPIMListHomePage } from "./pages/admin/SellerAdmin/PIM/Lists/SellerAdminPIMListHomePage";
import { ReferenceEntitiesList } from "./pages/admin/SellerAdmin/PIM/ReferenceEntities/ReferenceEntitiesList";
import { ReferenceEntityDetail } from "./pages/admin/SellerAdmin/PIM/ReferenceEntities/ReferenceEntityDetail";
import { CreatePimProductPage } from "./pages/SharedPages/OrganizationPage/ProductsList/CreatePimProductPage/CreatePimProductPage";
import { SellerAdminTemplateActivityTable } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/SellerAdminTemplateActivityTable";
import { AssetList } from "./pages/admin/SellerAdmin/PIM/SellarAdminPIMAssets/AssetsList/AssetsList";
import { SellerAdminRolesListingPage } from "./pages/admin/SellerAdmin/SellerAdminRoles/SellerAdminRolesListingPage";
import { SellerAdminRoleDetail } from "./pages/admin/SellerAdmin/SellerAdminRoleDetail/SellerAdminRoleDetail";
import { AttributesLandingPageRedirects } from "./pages/admin/SellerAdmin/PIM/SellerAdminPIMAttributes/AttributesRedirects";
import { BuyerProductDetailPortfolio } from "./pages/Buyer/BuyerProductDetailPortfolio/BuyerProductDetailPortfolio";
import { PublicProductDetailPortfolio } from "./pages/public/ProductDetailsPortfolio/PublicProductDetailPortfolio";
import { DistributorsList } from "./pages/Distributor/DistributorList/DistributorsList";
import { SellerAdminDistributorDetail } from "./pages/admin/SellerAdmin/SellerAdminDistributorDetail/SellerAdminDistributorDetail";
import { NotFoundPage } from "./pages/Misc/NotFoundPage";
import { BuyerProductsList } from "./pages/Buyer/BuyerProductsList/BuyerProductsList";
import { Dashboard } from "./pages/Seller/Dashboard/Dashboard";
import { GeneratedAssetsSettingsPage } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/TemplateGeneratedAssets/GeneratedAssetsSettingsPage";
import { SellerAdminTeamDetail } from "./pages/admin/SellerAdmin/SellerAdminTeams/SellerAdminTeamDetail";
import { SellerAdminTeamsListPageWrapper } from "./pages/admin/SellerAdmin/SellerAdminTeams/SellerAdminTeamsListWrapper";
import { AssetBulkUploadHomePage } from "./pages/admin/SellerAdmin/PIM/SellarAdminPIMAssets/BulkUploads/AssetBulkUploadHomePage";
import { ThankYouPage } from "./pages/public/ThankYouPage/ThankYouPage";
import { TwoFAPage } from "./pages/public/TwoFAPages/TwoFAPage";
import { SellerAdminTemplateViewTab } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/SellerAdminTemplateViewTab";
import { AssociateProducts } from "./pages/admin/SellerAdmin/PIM/SellarAdminPIMAssets/BulkUploads/AssociateProducts";
import { TemplateSettings } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/TemplateSettings";
import { BroadcastsPage } from "./pages/admin/SellerAdmin/Broadcasts/BroadcastsPage";
import { ButtonTestPage } from "./pages/TestPages/ButtonTestPage";
import { UnauthorizedPage } from "./pages/Misc/Unauthorized";
import { CreateTenantPage } from "./pages/SharedPages/CustomersListPage/CreateTenantPage";
import { TemplateFormsTab } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/TemplateFormsTab";
import { TemplateFormCreator } from "./pages/admin/SellerAdmin/PIM/SellerAdminTemplates/TemplateForms/TemplateFormCreator";
import { NewProductForm } from "./pages/SharedPages/OrganizationPage/ProductsList/NewProductForm/NewProductForm";
import { AutoCloseBrowserTab } from "./pages/Misc/autoCloseBrowserTab";
//MDM Routes
import { CustomersListPage } from "./pages/admin/SellerAdmin/MDM/Customers/CustomersListPage";
import { CreateCustomerPage } from "./pages/admin/SellerAdmin/MDM/Customers/CreateCustomerPage";
import { CustomerDetailPage } from "./pages/admin/SellerAdmin/MDM/Customers/CustomerDetailPage";
import { SuppliersListPage } from "./pages/admin/SellerAdmin/MDM/Suppliers/SuppliersListPage";
import { CreateSupplierPage } from "./pages/admin/SellerAdmin/MDM/Suppliers/CreateSupplierPage";
import { SupplierDetailPage } from "./pages/admin/SellerAdmin/MDM/Suppliers/SupplierDetailPage";
import { DistributorsListPage } from "./pages/admin/SellerAdmin/MDM/Distributors/DistributorsListPage";
import { CreateDistributorPage } from "./pages/admin/SellerAdmin/MDM/Distributors/CreateDistributorPage";
import { DistributorDetailPage } from "./pages/admin/SellerAdmin/MDM/Distributors/DistributorDetailPage";
import { ApprovalDashboard } from "./pages/admin/SellerAdmin/PIM/ApprovalDashboard/ApprovalDashboard";

// Internal-only admin dashboard — lazy-loaded so recharts (~200kb) only ships
// when an Agilis admin actually opens the page.
const LazyAgenticSearchOverview = lazy(() =>
  import("./pages/AgilisAdmin/AgenticSearchDashboard/Overview").then((m) => ({
    default: m.AgenticSearchOverview,
  }))
);
const LazyAgenticSearchInbox = lazy(() =>
  import("./pages/AgilisAdmin/AgenticSearchDashboard/FeedbackInbox").then(
    (m) => ({ default: m.AgenticSearchInbox })
  )
);
const LazyAgenticSearchSessionDetail = lazy(() =>
  import("./pages/AgilisAdmin/AgenticSearchDashboard/SessionDetail").then(
    (m) => ({ default: m.AgenticSearchSessionDetail })
  )
);
const AgenticSearchOverview = () => (
  <Suspense fallback={null}>
    <LazyAgenticSearchOverview />
  </Suspense>
);
const AgenticSearchInbox = () => (
  <Suspense fallback={null}>
    <LazyAgenticSearchInbox />
  </Suspense>
);
const AgenticSearchSessionDetail = () => (
  <Suspense fallback={null}>
    <LazyAgenticSearchSessionDetail />
  </Suspense>
);

// Wrapper components for routes
const CreateDistributorPageWrapper = () => (
  <CreateTenantPage customer_type="distributor" />
);
const CreateCustomerPageWrapper = () => (
  <CreateTenantPage customer_type="buyer" />
);

const routePaths: IRoutePaths = {
  accountPath: "/store/:tenantSlug/account",
  adminPath: "/store/:tenantSlug/admin",
  storePath: "/store/:tenantSlug",
};

const { accountPath, adminPath, storePath } = routePaths;

// ORDER FOR ROUTES:
// Dashboard and Analytics
// PIM:
// - products, templates, assets, attributes, list
// TRANSACTIONS:
// - orders, samples, quotes
// CHANNEL MANAGEMENT:
// - customers, storefronts
// MY ORGANIZATION:
// - company info, users, roles
// MARKETING:
// - leads, prospects, emails

export const DashboardAndAnalyticsRoutes: RouteType[] = [
  {
    path: `${adminPath}/dashboard`,
    component: Dashboard,
    browserTitle: "Dashboard",
    exact: true,
    layout: LayoutPortal,
    nav: {
      admin: { name: "Dashboard", icon: DashboardIcon },
      portal: { name: "Dashboard", icon: DashboardIcon },
    },
  },
];

export const SellerPIMRoutes: RouteType[] = [
  {
    path: `${adminPath}/pim/products`,
    component: ProductsList,
    browserTitle: "Products",
    exact: true,
    permission: "view_products",
    layout: LayoutPortal,
    parentNav: "MDM",
    nav: {
      admin: { name: "Products", icon: ProductsV2Icon },
      portal: { name: "Products", icon: ProductsV2Icon },
    },
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/products/new`,
    component: CreatePimProductPage,
    browserTitle: "Products",
    exact: true,
    layout: LayoutPortal,
    permission: "modify_products",
    // navName: "Seller Admin Product Detail",
  },
  {
    path: `${adminPath}/pim/compare-products`,
    component: CompareProductsPage,
    browserTitle: "Compare Products",
    exact: true,
    permission: "view_products",
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/products/new/product-via-form/:form_id`,
    component: NewProductForm,
    browserTitle: "New Product via Form",
    exact: true,
    layout: LayoutPortal,
    permission: "view_products",
    layoutProps: {
      noPadding: true,
      fullWidth: true,
    },
  },
  {
    path: `${adminPath}/pim/products/:product_id`,
    component: SellerAdminProductDetail,
    browserTitle: "Products",
    exact: true,
    permission: "view_products",
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
    // navName: "Seller Admin Product Detail",
  },
  {
    path: `${adminPath}/pim/products/:product_id/approvals/:approval_id`,
    component: ApprovalDetailPage,
    browserTitle: "Approval Details",
    exact: true,
    permission: "view_products",
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/pim/approvals`,
    component: ApprovalDashboard,
    exact: true,
    browserTitle: "Approvals",
    permission: "modify_products",
    metaName: "enable_approval_workflow",
    layout: LayoutPortal,
    parentNav: "MDM",
    nav: {
      admin: { name: "Approvals", icon: FlagIcon },
      portal: { name: "Approvals", icon: FlagIcon },
    },
  },
  {
    path: `${adminPath}/pim/assets`,
    component: AssetList,
    browserTitle: "Assets",
    exact: true,
    permission: "view_assets",
    layout: LayoutPortal,
    parentNav: "MDM",
    nav: {
      admin: { name: "Assets", icon: AssetsIcon },
      portal: { name: "Assets", icon: AssetsIcon },
    },
  },
  {
    path: `${adminPath}/pim/templates`,
    component: SellerAdminTemplateListingPage,
    browserTitle: "Templates",
    exact: true,
    permission: "view_templates",
    parentNav: "MDM",
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
    nav: {
      admin: { name: "Templates", icon: TemplatesNavIcon },
      portal: { name: "Templates", icon: TemplatesNavIcon },
    },
  },
  {
    path: `${adminPath}/pim/assets/uploads`,
    component: AssetBulkUploadHomePage,
    browserTitle: "Assets",
    exact: true,
    permission: ["view_assets", "modify_assets"],
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/pim/assets/associate-products`,
    component: AssociateProducts,
    browserTitle: "Associate Products",
    exact: true,
    permission: ["view_assets", "modify_assets"],
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/pim/assets/:assetId`,
    component: AssetList,
    browserTitle: "Assets",
    exact: true,
    permission: "view_assets",
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/pim/templates/:template_id/groups`,
    component: SellerAdminTemplateGroupDetail,
    browserTitle: "Templates",
    permission: "view_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/groups/:group_id`,
    component: AttributeGroupDetail,
    browserTitle: "Attribute group detail",
    permission: "view_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/assets`,
    component: GeneratedAssetsSettingsPage,
    browserTitle: "Templates",
    permission: ["view_templates", "modify_templates"],
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/activity`,
    component: SellerAdminTemplateActivityTable,
    browserTitle: "Templates",
    permission: "view_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/view`,
    component: SellerAdminTemplateViewTab,
    browserTitle: "Templates",
    permission: "view_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/forms`,
    component: TemplateFormsTab,
    browserTitle: "Templates",
    permission: "view_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/forms/:form_id`,
    component: TemplateFormCreator,
    browserTitle: "Templates",
    permission: "modify_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/forms/new`,
    component: TemplateFormCreator,
    browserTitle: "Templates",
    permission: "modify_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/collections`,
    component: SellerAdminTemplateCollectionTable,
    browserTitle: "template collections",
    permission: "view_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/collections/:id`,
    component: SellerAdminAttributesCollectionDetails,
    browserTitle: "Collection Details",
    permission: "view_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/templates/:template_id/settings`,
    component: TemplateSettings,
    browserTitle: "Template Settings",
    permission: "view_templates",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/attributes`,
    component: AttributesLandingPageRedirects,
    browserTitle: "Attributes",
    exact: true,
    // despite the name of the URL, this page is a tabbed page containing
    // groups/collections/attributes.
    // We need one of the below permissions to view it.
    permission: ["view_attributes", "view_collections", "view_groups"],
    layout: LayoutPortal,
    parentNav: "MDM",
    nav: {
      admin: { name: "Attributes", icon: AttributesNavIcon },
      portal: { name: "Attributes", icon: AttributesNavIcon },
    },
  },
  {
    path: `${adminPath}/pim/attributes/collections`,
    component: SellerAdminAttributesCollectionsList,
    browserTitle: "Attribute Collections",
    permission: "view_collections",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/pim/attributes/collections/:id`,
    component: SellerAdminAttributesCollectionDetails,
    browserTitle: "Collection Details",
    permission: "view_collections",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/attributes/groups`,
    component: SellerAdminPIMAttributeGroups,
    browserTitle: "Attribute groups",
    permission: "view_groups",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/pim/attributes/groups/:group_id`,
    component: AttributeGroupDetail,
    browserTitle: "Attribute group detail",
    permission: "view_groups",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/lists`,
    component: SellerAdminPIMListHomePage,
    browserTitle: "Lists",
    exact: true,
    permission: "view_lists",
    layout: LayoutPortal,
    parentNav: "MDM",
    nav: {
      admin: { name: "Lists", icon: ListsIcon },
      portal: { name: "Lists", icon: ListsIcon },
    },
  },
  {
    path: `${adminPath}/pim/reference-entities`,
    component: ReferenceEntitiesList,
    browserTitle: "Reference Entities",
    exact: true,
    permission: "view_products",
    metaName: "enable_reference_entities",
    layout: LayoutPortal,
    parentNav: "MDM",
    nav: {
      admin: { name: "Reference Entities", icon: ReferenceEntitiesIcon },
      portal: { name: "Reference Entities", icon: ReferenceEntitiesIcon },
    },
  },
  {
    path: `${adminPath}/pim/reference-entities/:reference_entity_id`,
    component: ReferenceEntityDetail,
    browserTitle: "Reference Entity Detail",
    exact: true,
    permission: "view_products",
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/pim/attributes/:id`,
    component: AttributeDetailPage,
    permission: "view_attributes",
    exact: true,
    layout: LayoutPortal,
  },
];

export const MDMRoutes: RouteType[] = [
  {
    path: `${adminPath}/mdm/customers`,
    component: CustomersListPage,
    browserTitle: "Customers",
    exact: true,
    layout: LayoutPortal,
    metaName: "enable_customer",
    permission: "view_customers",
    parentNav: "MDM",
    layoutProps: { fullWidth: true, noPadding: true },
    nav: {
      admin: { name: "Customers", icon: UsersIcon },
      portal: { name: "Customers", icon: UsersIcon },
    },
  },
  {
    path: `${adminPath}/mdm/customers/new`,
    component: CreateCustomerPage,
    browserTitle: "Create Customer",
    exact: true,
    metaName: "enable_customer",
    permission: "modify_customers",
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/mdm/customers/:entity_id`,
    component: CustomerDetailPage,
    browserTitle: "Customer",
    exact: true,
    metaName: "enable_customer",
    permission: "view_customers",
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/mdm/distributors`,
    component: DistributorsListPage,
    browserTitle: "Distributors",
    exact: true,
    layout: LayoutPortal,
    metaName: "enable_distributor",
    permission: "view_distributors",
    parentNav: "MDM",
    layoutProps: { fullWidth: true, noPadding: true },
    nav: {
      admin: { name: "Distributors", icon: DistributorsIcon },
      portal: { name: "Distributors", icon: DistributorsIcon },
    },
  },
  {
    path: `${adminPath}/mdm/distributors/new`,
    component: CreateDistributorPage,
    browserTitle: "Create Distributor",
    exact: true,
    metaName: "enable_distributor",
    permission: "modify_distributors",
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/mdm/distributors/:entity_id`,
    component: DistributorDetailPage,
    browserTitle: "Distributor",
    exact: true,
    metaName: "enable_distributor",
    permission: "view_distributors",
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/mdm/suppliers`,
    component: SuppliersListPage,
    browserTitle: "Suppliers",
    exact: true,
    layout: LayoutPortal,
    metaName: "enable_supplier",
    permission: "view_suppliers",
    parentNav: "MDM",
    layoutProps: { fullWidth: true, noPadding: true },
    nav: {
      admin: { name: "Suppliers", icon: CompanyIcon },
      portal: { name: "Suppliers", icon: CompanyIcon },
    },
  },
  {
    path: `${adminPath}/mdm/suppliers/new`,
    component: CreateSupplierPage,
    browserTitle: "Create Supplier",
    exact: true,
    metaName: "enable_supplier",
    permission: "view_suppliers",
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/mdm/suppliers/:entity_id`,
    component: SupplierDetailPage,
    browserTitle: "Supplier",
    exact: true,
    metaName: "enable_supplier",
    permission: "view_suppliers",
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
];

export const SellerAdminRoutes: RouteType[] = [
  // SELLER ADMIN NAV LINK ROUTES - In the order they appear in the nav bars.
  // PIM
  // CHANNEL MANAGEMENT
  {
    path: `${adminPath}/tenants`,
    component: SellerAdminCustomersList,
    browserTitle: "Customers",
    exact: true,
    layout: LayoutPortal,
    metaName: "enable_customer_portal",
    parentNav: "CHANNEL MANAGEMENT",
    nav: {
      admin: { name: "Customers", icon: UsersIcon },
      portal: { name: "Customers", icon: UsersIcon },
    },
  },
  {
    path: `${adminPath}/distributors`,
    component: DistributorsList,
    browserTitle: "Distributors",
    exact: true,
    layout: LayoutPortal,
    metaName: "enable_customer_portal",
    parentNav: "CHANNEL MANAGEMENT",
    nav: {
      admin: { name: "Distributors", icon: DistributorsIcon },
      portal: { name: "Distributors", icon: DistributorsIcon },
    },
  },
  // MARKETING
  {
    path: `${adminPath}/leads`,
    component: pageForEdition({
      DefaultPage: SellerAdminLeadsList,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Leads",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MARKETING",
    nav: {
      admin: { name: "Leads", icon: LeadsIcon },
      portal: { name: "Leads", icon: LeadsIcon },
    },
  },
  {
    path: `${adminPath}/prospects`,
    component: pageForEdition({
      DefaultPage: ProspectsListPage,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    metaName: "digital_marketing_enabled",
    browserTitle: "Prospects",
    exact: true,
    layout: LayoutPortal,
    nav: {
      portal: { name: "Prospects", icon: OpportunitiesIcon },
      admin: { name: "Prospects", icon: OpportunitiesIcon },
    },
  },
  {
    path: `${adminPath}/marketing`,
    component: pageForEdition({
      DefaultPage: MarketingListPage,
      StarterEditionPage: NotSupportedForEdition,
    }),
    metaName: "digital_marketing_enabled",
    browserTitle: "Marketing",
    exact: true,
    layout: LayoutPortal,
    nav: {
      portal: { name: "Marketing", icon: AnalyticsIcon },
      admin: { name: "Marketing", icon: AnalyticsIcon },
    },
  },
  {
    path: `${adminPath}/broadcasts`,
    component: BroadcastsPage,
    browserTitle: "Broadcasts",
    exact: true,
    layout: LayoutPortal,
  },
  // TEST PAGES
  {
    path: `${adminPath}/test/buttons`,
    component: ButtonTestPage,
    browserTitle: "Button Test Page",
    exact: true,
    layout: LayoutPortal,
  },
  // ORGANIZATION
  {
    path: `${adminPath}/organization`,
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Company Info",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization/company-info`,
    component: SellerAdminOrganization,
    browserTitle: "Organization Company Info",
    parentNav: "MY ORGANIZATION",
    exact: true,
    layout: LayoutPortal,
    nav: {
      admin: { name: "Company Info", icon: CompanyIcon },
      portal: { name: "Company Info", icon: CompanyIcon },
    },
  },
  {
    path: `${adminPath}/organization/regions`,
    component: SellerAdminOrganization,
    browserTitle: "Regions",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization/teams`,
    component: SellerAdminTeamsListPageWrapper,
    browserTitle: "Teams",
    parentNav: "MY ORGANIZATION",
    exact: true,
    layout: LayoutPortal,
    nav: {
      admin: { name: "Teams", icon: TeamsIcon },
      portal: { name: "Teams", icon: TeamsIcon },
    },
  },

  {
    path: `${adminPath}/organization/teams/:team_id`,
    component: SellerAdminTeamDetail,
    browserTitle: "Teams",
    parentNav: "MY ORGANIZATION",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization/roles`,
    component: SellerAdminRolesListingPage,
    browserTitle: "Organization Roles",
    parentNav: "MY ORGANIZATION",
    exact: true,
    layout: LayoutPortal,
    nav: {
      admin: { name: "Roles", icon: RolesUserIcon },
      portal: { name: "Roles", icon: RolesUserIcon },
    },
  },
  {
    path: `${adminPath}/organization/users`,
    component: SellerAdminOrganization,
    browserTitle: "Organization Users",
    parentNav: "MY ORGANIZATION",
    exact: true,
    layout: LayoutPortal,
    nav: {
      admin: { name: "Users", icon: UsersIcon },
      portal: { name: "Users", icon: UsersIcon },
    },
  },

  {
    path: `${adminPath}/organization/roles/:role_id`,
    component: SellerAdminRoleDetail,
    browserTitle: "Role Detail",
    exact: true,
    layout: LayoutPortal,
  },

  {
    path: `${adminPath}/manage`,
    // This route just redirects to `/organization`.
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Organization",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: adminPath,
    // This route just redirects to `/organization`, the default landing page
    // for seller admins. Its forseeable that someone might go back to "home" by
    // typing in /store/{slug}/admin, which would 404 without this route.
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Organization",
    exact: true,
    layout: LayoutPortal,
  },
  // TRANSACTIONS
  {
    path: `${accountPath}/orders`,
    component: pageForEdition({
      DefaultPage: SellerOrdersList,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Seller Orders",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Orders", icon: OrderIcon },
      admin: { name: "Orders", icon: OrderIcon },
      public: { name: "Orders", icon: OrderIcon },
    },
  },
  {
    path: `${accountPath}/samples`,
    component: pageForEdition({
      DefaultPage: SellerSampleRequests,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Requests",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      admin: { name: "Samples", icon: LabFlaskIcon },
      portal: { name: "Samples", icon: LabFlaskIcon },
    },
  },
  {
    path: `${accountPath}/quotes`,
    component: pageForEdition({
      DefaultPage: SellerQuotesList,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Quotes",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Quotes", icon: QuoteIcon },
      admin: { name: "Quotes", icon: QuoteIcon },
    },
  },
  {
    path: `${adminPath}/settings`,
    component: SellerAdminSettings,
    browserTitle: "Seller Admin Settings",
    exact: true,
    layout: LayoutPortal,
  },

  // SELLER ADMIN NON-NAV LINK ROUTES - In alphabetical order by "path".

  {
    path: `${adminPath}/leads/:lead_id`,
    component: pageForEdition({
      DefaultPage: SellerAdminLeadDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Seller Admin Lead Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/sample-requests/:sample_request_id`,
    component: pageForEdition({
      DefaultPage: SellerAdminSampleRequestLeadDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Seller Admin Sample Request Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/orders/:order_id`,
    component: pageForEdition({
      DefaultPage: SellerOrderDetail,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Order Detail",
    exact: true,
    layout: LayoutPortal,
  },
  // User preferences will likely eventually exist for
  // every user type but its not clear whether they can share
  // a component. So for now this is here.
  {
    path: `${adminPath}/preferences`,
    component: UserPreferences,
    browserTitle: "Seller Admin Preferences",
    exact: true,
    layout: LayoutPortal,
  },
  // The below only exists temporarily until seller and seller standard route
  // trees diverge.
  {
    path: `${accountPath}/preferences`,
    component: UserPreferences,
    browserTitle: "Seller Standard Preferences",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/prospects/list/:list_id`,
    component: pageForEdition({
      DefaultPage: ProspectsListDetails,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Prospects List Details",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/registration/:lead_id`,
    component: pageForEdition({
      DefaultPage: LeadDetailPage,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Registration Lead",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/contact-us/:lead_id`,
    component: pageForEdition({
      DefaultPage: LeadDetailPage,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Contact us lead",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/quotes/:quote_id`,
    component: pageForEdition({
      DefaultPage: SellerQuoteDetail,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Quote Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/samples/:sample_request_id`,
    component: pageForEdition({
      DefaultPage: SellerSampleRequestDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Request",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/tenants/:tenant_id`,
    component: SellerAdminCustomerDetail,
    browserTitle: "Customer Details",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/distributors/:distributor_id`,
    component: SellerAdminDistributorDetail,
    browserTitle: "Distributor Details",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/users/:user_id`,
    component: SellerAdminUserDetail,
    browserTitle: "Seller Admin User Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${storePath}/support`,
    component: SupportPage,
    exact: true,
    layout: LayoutPortal,
  },
];

/**
 * Routes for standard sellers, they cannot CRUD users/roles
 */
export const SellerRoutes: RouteType[] = [
  // SELLER ADMIN NAV LINK ROUTES - In the order they appear in the nav bars.
  // Dashboard
  // PIM
  // CHANNEL MANAGEMENT
  {
    path: `${adminPath}/tenants`,
    component: SellerAdminCustomersList,
    browserTitle: "Customers",
    exact: true,
    layout: LayoutPortal,
    metaName: "enable_customer_portal",
    parentNav: "CHANNEL MANAGEMENT",
    nav: {
      admin: { name: "Customers", icon: UsersIcon },
      portal: { name: "Customers", icon: UsersIcon },
    },
  },
  {
    path: `${adminPath}/distributors`,
    component: DistributorsList,
    browserTitle: "Distributors",
    exact: true,
    layout: LayoutPortal,
    metaName: "enable_customer_portal",
    parentNav: "CHANNEL MANAGEMENT",
    nav: {
      admin: { name: "Distributors", icon: DistributorsIcon },
      portal: { name: "Distributors", icon: DistributorsIcon },
    },
  },
  // MARKETING
  {
    path: `${adminPath}/leads`,
    component: pageForEdition({
      DefaultPage: SellerAdminLeadsList,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Leads",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MARKETING",
    nav: {
      admin: { name: "Leads", icon: LeadsIcon },
      portal: { name: "Leads", icon: LeadsIcon },
    },
  },
  {
    path: `${adminPath}/prospects`,
    component: pageForEdition({
      DefaultPage: ProspectsListPage,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
      BusinessEditionPage: NotSupportedForEdition,
    }),
    metaName: "digital_marketing_enabled",
    browserTitle: "Prospects",
    exact: true,
    layout: LayoutPortal,
    nav: {
      portal: { name: "Prospects", icon: OpportunitiesIcon },
      admin: { name: "Prospects", icon: OpportunitiesIcon },
    },
  },
  {
    path: `${adminPath}/marketing`,
    component: pageForEdition({
      DefaultPage: MarketingListPage,
      StarterEditionPage: NotSupportedForEdition,
    }),
    metaName: "digital_marketing_enabled",
    browserTitle: "Marketing",
    exact: true,
    layout: LayoutPortal,
    nav: {
      portal: { name: "Marketing", icon: AnalyticsIcon },
      admin: { name: "Marketing", icon: AnalyticsIcon },
    },
  },
  // ORGANIZATION
  {
    path: `${adminPath}/organization`,
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Company Info",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization/company-info`,
    component: SellerAdminOrganization,
    browserTitle: "Organization Company Info",
    parentNav: "MY ORGANIZATION",
    exact: true,
    layout: LayoutPortal,
    nav: {
      admin: { name: "Company Info", icon: CompanyIcon },
      portal: { name: "Company Info", icon: CompanyIcon },
    },
  },
  {
    path: `${adminPath}/organization/teams`,
    component: SellerAdminTeamsListPageWrapper,
    browserTitle: "Teams",
    parentNav: "MY ORGANIZATION",
    exact: true,
    layout: LayoutPortal,
    nav: {
      admin: { name: "Teams", icon: TeamsIcon },
      portal: { name: "Teams", icon: TeamsIcon },
    },
  },
  {
    path: `${adminPath}/organization/teams/:team_id`,
    component: SellerAdminTeamDetail,
    browserTitle: "Teams",
    parentNav: "MY ORGANIZATION",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/manage`,
    // This route just redirects to `/organization`.
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Organization",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: adminPath,
    // This route just redirects to `/organization`, the default landing page
    // for seller admins. Its forseeable that someone might go back to "home" by
    // typing in /store/{slug}/admin, which would 404 without this route.
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Organization",
    exact: true,
    layout: LayoutPortal,
  },
  // TRANSACTIONS
  {
    path: `${accountPath}/orders`,
    component: pageForEdition({
      DefaultPage: SellerOrdersList,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Seller Orders",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Orders", icon: OrderIcon },
      admin: { name: "Orders", icon: OrderIcon },
    },
  },
  {
    path: `${accountPath}/samples`,
    component: pageForEdition({
      DefaultPage: SellerSampleRequests,
      PIMBasicEditionPage: NotSupportedForEdition,
      StarterEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Requests",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      admin: { name: "Samples", icon: LabFlaskIcon },
      portal: { name: "Samples", icon: LabFlaskIcon },
    },
  },
  {
    path: `${accountPath}/quotes`,
    component: pageForEdition({
      DefaultPage: SellerQuotesList,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Quotes",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Quotes", icon: QuoteIcon },
      admin: { name: "Quotes", icon: QuoteIcon },
    },
  },
  {
    path: `${adminPath}/settings`,
    component: SellerAdminSettings,
    browserTitle: "Seller Admin Settings",
    exact: true,
    layout: LayoutPortal,
  },

  // SELLER ADMIN NON-NAV LINK ROUTES - In alphabetical order by "path".

  {
    path: `${adminPath}/leads/:lead_id`,
    component: pageForEdition({
      DefaultPage: SellerAdminLeadDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Seller Admin Lead Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/sample-requests/:sample_request_id`,
    component: pageForEdition({
      DefaultPage: SellerAdminSampleRequestLeadDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Seller Admin Sample Request Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/orders/:order_id`,
    component: pageForEdition({
      DefaultPage: SellerOrderDetail,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Order Detail",
    exact: true,
    layout: LayoutPortal,
  },
  // User preferences will likely eventually exist for
  // every user type but its not clear whether they can share
  // a component. So for now this is here.
  {
    path: `${adminPath}/preferences`,
    component: UserPreferences,
    browserTitle: "Seller Admin Preferences",
    exact: true,
    layout: LayoutPortal,
  },
  // The below only exists temporarily until seller and seller standard route
  // trees diverge.
  {
    path: `${accountPath}/preferences`,
    component: UserPreferences,
    browserTitle: "Seller Standard Preferences",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/prospects/list/:list_id`,
    component: pageForEdition({
      DefaultPage: ProspectsListDetails,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
      BusinessEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Prospects List Details",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/registration/:lead_id`,
    component: pageForEdition({
      DefaultPage: LeadDetailPage,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Registration Lead",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/contact-us/:lead_id`,
    component: pageForEdition({
      DefaultPage: LeadDetailPage,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Contact us lead",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/quotes/:quote_id`,
    component: pageForEdition({
      DefaultPage: SellerQuoteDetail,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Quote Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/samples/:sample_request_id`,
    component: pageForEdition({
      DefaultPage: SellerSampleRequestDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
      StarterEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Request",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/tenants/:tenant_id`,
    component: SellerAdminCustomerDetail,
    browserTitle: "Customer Details",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/distributors/:distributor_id`,
    component: SellerAdminDistributorDetail,
    browserTitle: "Distributor Details",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${storePath}/support`,
    component: SupportPage,
    exact: true,
    layout: LayoutPortal,
  },
];

export const AgilisAdminRoutes: RouteType[] = [
  {
    path: `${adminPath}/agentic-search`,
    component: AgenticSearchOverview,
    layout: LayoutPortal,
    layoutProps: { fullWidth: true, noPadding: true },
    exact: true,
    browserTitle: "Agentic Search · Admin",
  },
  {
    path: `${adminPath}/agentic-search/inbox`,
    component: AgenticSearchInbox,
    layout: LayoutPortal,
    layoutProps: { fullWidth: true, noPadding: true },
    exact: true,
    browserTitle: "Agentic Search · Inbox",
  },
  {
    path: `${adminPath}/agentic-search/sessions/:sessionId`,
    component: AgenticSearchSessionDetail,
    layout: LayoutPortal,
    layoutProps: { fullWidth: true, noPadding: true },
    exact: true,
    browserTitle: "Agentic Search · Session",
  },
  {
    path: `${adminPath}/tenants/bulk-price-tiers`,
    component: pageForEdition({
      EnterpriseEditionPage:
        require("./pages/SharedPages/CustomersListPage/BulkUploadPriceTiers/BulkUploadPriceTiers")
          .BulkUploadPriceTiers,
      DefaultPage: NotSupportedForEdition,
    }),
    layout: LayoutPortal,
    exact: true,
    browserTitle: "Bulk Price Tiers",
  },
  {
    path: `${adminPath}/distributors/create`,
    component: CreateDistributorPageWrapper,
    browserTitle: "Distributors",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/customers/create`,
    component: CreateCustomerPageWrapper,
    browserTitle: "Customers",
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  ...SellerAdminRoutes,
];

export const BuyerUnactivatedRoutes: RouteType[] = [
  {
    path: `${adminPath}/organization`,
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Company Info",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization/company-info`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization Info",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Company Info", icon: CompanyIcon },
      portal: { name: "Company Info", icon: CompanyIcon },
    },
  },
  {
    path: `${adminPath}/preferences`,
    component: UserPreferences,
    browserTitle: "Buyer Admin Preferences",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${storePath}/support`,
    component: SupportPage,
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: "/*",
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Company Info",
    exact: true,
    layout: LayoutPortal,
  },
];

export const BuyerAdminPIMRoutes: RouteType[] = [
  {
    path: `${storePath}/home`,
    component: Homepage,
    exact: true,
    layout: LayoutPublic,
    nav: {
      public: { name: "Home" },
    },
    layoutProps: {
      fullWidth: true,
    },
  },
  {
    path: `${storePath}/portfolio`,
    component: PublicIndexWrapper,
    exact: true,
    layout: LayoutPortal,
    nav: {
      public: { name: "Portfolio" },
    },
  },
  {
    path: `${adminPath}/pim/products`,
    component: BuyerProductsList,
    browserTitle: "Products",
    exact: false,
    permission: "view_products",
    layout: LayoutPortal,
    parentNav: "MDM",
    nav: {
      admin: { name: "Products", icon: ProductsV2Icon },
      portal: { name: "Products", icon: ProductsV2Icon },
    },
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/pim/products/:productSlug`,
    component: BuyerProductsList,
    browserTitle: "Products",
    exact: false,
    // permission: "view_products",
    layout: LayoutPortal,
    parentNav: "MDM",
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${storePath}/product/:productSlug`,
    component: BuyerProductDetailPortfolio,
    exact: true,
    permission: "view_products",
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${adminPath}/organization`,
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Company Info",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization/company-info`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization Info",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Company Info", icon: CompanyIcon },
      portal: { name: "Company Info", icon: CompanyIcon },
    },
  },
  {
    path: `${adminPath}/organization/users`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization Users",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Users", icon: UsersIcon },
      portal: { name: "Users", icon: UsersIcon },
    },
  },
  {
    path: `${adminPath}/organization/settings`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization settings",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Settings", icon: SettingsIcon },
      portal: { name: "Settings", icon: SettingsIcon },
    },
  },
  {
    path: `${adminPath}/preferences`,
    component: UserPreferences,
    browserTitle: "Buyer Admin Preferences",
    exact: true,
    layout: LayoutPortal,
  },
];

export const BuyerAdminRoutes: RouteType[] = [
  {
    path: `${storePath}/home`,
    component: Homepage,
    exact: true,
    layout: LayoutPublic,
    // nav: {
    //   public: { name: "Home" },
    //   portal: { name: "Home" },
    // },
    layoutProps: {
      fullWidth: true,
    },
  },
  {
    path: `${storePath}/portfolio`,
    component: PublicIndexWrapper,
    exact: true,
    layout: LayoutPortal,
    nav: {
      public: { name: "Portfolio" },
    },
  },
  {
    path: `${adminPath}/pim/products`,
    component: BuyerProductsList,
    browserTitle: "Products",
    exact: true,
    permission: "view_products",
    layout: LayoutPortal,
    layoutProps: { noPadding: true },
    parentNav: "MDM",
    nav: {
      admin: { name: "Products", icon: ProductsV2Icon },
      portal: { name: "Products", icon: ProductsV2Icon },
    },
  },
  {
    path: `${adminPath}/pim/products/:productSlug`,
    component: BuyerProductsList,
    browserTitle: "Products",
    exact: false,
    // permission: "view_products",
    layout: LayoutPortal,
    layoutProps: { noPadding: true },
  },
  {
    path: `${storePath}/product/:productSlug`,
    component: BuyerProductDetailPortfolio,
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${storePath}/cart`,
    component: CartSwitcherBuyer,
    exact: false,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/manage`,
    // This route just redirects to `/organization`.
    component: () => (
      <RedirectPage routePathKey={"adminPath"} path={"/organization"} />
    ),
    browserTitle: "Organization",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/my-products`,
    component: BuyerMyProducts,
    browserTitle: "My Products",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      admin: { name: "My Products", icon: PersonalCollectionIcon },
      portal: { name: "My Products", icon: PersonalCollectionIcon },
    },
  },
  {
    path: `${accountPath}/my-products/tiers/:product_id`,
    component: BuyerMyProductsPriceTiers,
    browserTitle: "My Products detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/orders/:orderId`,
    component: pageForEdition({
      DefaultPage: BuyerOrderDetailWrapper,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Order Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/orders`,
    component: pageForEdition({
      DefaultPage: BuyerOrders,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Orders",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Orders", icon: OrderIcon },
      admin: { name: "Orders", icon: OrderIcon },
    },
  },
  {
    path: `${accountPath}/orders/:orderId`,
    component: pageForEdition({
      DefaultPage: BuyerOrderDetailWrapper,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Order Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization`,
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Company Info",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization/company-info`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization Info",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Company Info", icon: CompanyIcon },
      portal: { name: "Company Info", icon: CompanyIcon },
    },
  },
  {
    path: `${adminPath}/organization/users`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization Users",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Users", icon: UsersIcon },
      portal: { name: "Users", icon: UsersIcon },
    },
  },
  {
    path: `${adminPath}/organization/settings`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization settings",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Settings", icon: SettingsIcon },
      portal: { name: "Settings", icon: SettingsIcon },
    },
  },
  {
    path: `${accountPath}/quotes`,
    component: pageForEdition({
      DefaultPage: BuyerQuotesList,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Quotes",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Quotes", icon: QuoteIcon },
      admin: { name: "Quotes", icon: QuoteIcon },
    },
  },
  {
    path: `${accountPath}/samples`,
    component: pageForEdition({
      DefaultPage: BuyerSampleRequests,
      StarterEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Requests",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Samples", icon: LabFlaskIcon },
      admin: { name: "Samples", icon: LabFlaskIcon },
    },
  },
  {
    path: `${accountPath}/samples/:sample_request_id`,
    component: pageForEdition({
      DefaultPage: BuyerSampleRequestDetail,
      StarterEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Request",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/quotes/:quoteId`,
    component: pageForEdition({
      DefaultPage: BuyerQuoteDetail,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Quote Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/preferences`,
    component: UserPreferences,
    browserTitle: "Buyer Admin Preferences",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${storePath}/support`,
    component: SupportPage,
    exact: true,
    layout: LayoutPortal,
  },
];

export const BuyerRoutes: RouteType[] = [
  {
    path: `${storePath}/home`,
    component: Homepage,
    exact: true,
    layout: LayoutPublic,
    nav: {
      public: { name: "Home" },
      portal: { name: "Home", icon: HomeIcon },
    },
    layoutProps: {
      fullWidth: true,
    },
  },
  {
    path: `${accountPath}/preferences`,
    // We don't have a another RouteType array for all logged in users because
    // this component has a different path depending on role
    component: UserPreferences,
    browserTitle: "Buyer Preferences",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/my-products`,
    component: BuyerMyProducts,
    browserTitle: "My Products",
    exact: true,
    layout: LayoutPortal,
    nav: {
      // TODO: add correct icon
      admin: { name: "My Products", icon: SoldByIcon },
      portal: { name: "My Products", icon: SoldByIcon },
    },
  },
  {
    path: `${accountPath}/my-products/tiers/:product_id`,
    component: BuyerMyProductsPriceTiers,
    browserTitle: "My Products detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${storePath}/portfolio`,
    component: PublicIndexWrapper,
    exact: true,
    layout: LayoutPortal,
    nav: {
      public: { name: "Portfolio" },
      portal: { name: "Portfolio", icon: StackIcon },
    },
  },
  {
    path: `${storePath}/product/:productSlug`,
    component: BuyerProductDetailPortfolio,
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${storePath}/cart`,
    component: CartSwitcherBuyer,
    exact: false,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/orders`,
    component: pageForEdition({
      DefaultPage: BuyerOrders,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Orders",
    exact: true,
    layout: LayoutPortal,
    nav: { portal: { name: "Orders", icon: OrderIcon } },
  },
  {
    path: `${accountPath}/orders/:orderId`,
    component: pageForEdition({
      DefaultPage: BuyerOrderDetailWrapper,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Order Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/organization`,
    component: BuyerOrganization,
    browserTitle: "Organization",
    exact: true,
    layout: LayoutPortal,
    nav: {
      portal: { name: "Organization", icon: CompanyIcon },
    },
  },

  {
    path: `${accountPath}/quotes`,
    component: pageForEdition({
      DefaultPage: BuyerQuotesList,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Quotes",
    exact: true,
    layout: LayoutPortal,
    nav: { portal: { name: "Quotes", icon: QuoteIcon } },
  },
  {
    path: `${accountPath}/quotes/:quoteId`,
    component: pageForEdition({
      DefaultPage: BuyerQuoteDetail,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Quote Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/samples`,
    component: pageForEdition({
      DefaultPage: BuyerSampleRequests,
      PIMBasicEditionPage: NotSupportedForEdition,
      StarterEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Requests",
    exact: true,
    layout: LayoutPortal,
    nav: {
      portal: { name: "Samples", icon: LabFlaskIcon },
      admin: { name: "Samples", icon: LabFlaskIcon },
    },
  },
  {
    path: `${accountPath}/samples/:sample_request_id`,
    component: pageForEdition({
      DefaultPage: BuyerSampleRequestDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
      StarterEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Request",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${storePath}/support`,
    component: SupportPage,
    exact: true,
    layout: LayoutPortal,
  },
];

export const DistributorAdminRoutes: RouteType[] = [
  {
    path: `${storePath}/home`,
    component: Homepage,
    exact: true,
    layout: LayoutPublic,
    // nav: {
    //   public: { name: "Home" },
    //   portal: { name: "Home" },
    // },
    layoutProps: {
      fullWidth: true,
    },
  },
  {
    path: `${storePath}/portfolio`,
    component: PublicIndexWrapper,
    exact: true,
    layout: LayoutPortal,
    nav: {
      public: { name: "Portfolio" },
    },
  },
  {
    path: `${adminPath}/pim/products`,
    component: BuyerProductsList,
    browserTitle: "Products",
    exact: true,
    permission: "view_products",
    layout: LayoutPortal,
    parentNav: "MDM",
    nav: {
      admin: { name: "Products", icon: ProductsV2Icon },
      portal: { name: "Products", icon: ProductsV2Icon },
    },
  },
  {
    path: `${adminPath}/pim/products/:productSlug`,
    component: BuyerProductsList,
    browserTitle: "Products",
    exact: false,
    // permission: "view_products",
    layout: LayoutPortal,
  },
  {
    path: `${storePath}/product/:productSlug`,
    component: BuyerProductDetailPortfolio,
    exact: true,
    layout: LayoutPortal,
    layoutProps: {
      noPadding: true,
    },
  },
  {
    path: `${storePath}/cart`,
    component: CartSwitcherBuyer,
    exact: false,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/manage`,
    // This route just redirects to `/organization`.
    component: () => (
      <RedirectPage routePathKey={"adminPath"} path={"/organization"} />
    ),
    browserTitle: "Organization",
    exact: true,
    layout: LayoutPortal,
  },
  // MARKETING
  {
    path: `${adminPath}/leads`,
    component: pageForEdition({
      DefaultPage: SellerAdminLeadsList,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Leads",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MARKETING",
    nav: {
      admin: { name: "Leads", icon: LeadsIcon },
      portal: { name: "Leads", icon: LeadsIcon },
    },
  },
  {
    path: `${adminPath}/leads/:lead_id`,
    component: pageForEdition({
      DefaultPage: SellerAdminLeadDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Seller Admin Lead Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/sample-requests/:sample_request_id`,
    component: pageForEdition({
      DefaultPage: SellerAdminSampleRequestLeadDetail,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Seller Admin Sample Request Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/registration/:lead_id`,
    component: pageForEdition({
      DefaultPage: LeadDetailPage,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Registration Lead",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/leads/contact-us/:lead_id`,
    component: pageForEdition({
      DefaultPage: LeadDetailPage,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Contact us lead",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/my-products`,
    component: BuyerMyProducts,
    browserTitle: "My Products",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      admin: { name: "My Products", icon: PersonalCollectionIcon },
      portal: { name: "My Products", icon: PersonalCollectionIcon },
    },
  },
  {
    path: `${accountPath}/my-products/tiers/:product_id`,
    component: BuyerMyProductsPriceTiers,
    browserTitle: "My Products detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/orders/:orderId`,
    component: pageForEdition({
      DefaultPage: BuyerOrderDetailWrapper,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Order Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/orders`,
    component: pageForEdition({
      DefaultPage: BuyerOrders,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Orders",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Orders", icon: OrderIcon },
      admin: { name: "Orders", icon: OrderIcon },
    },
  },
  {
    path: `${accountPath}/orders/:orderId`,
    component: pageForEdition({
      DefaultPage: BuyerOrderDetailWrapper,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Order Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization`,
    component: () => (
      <RedirectPage
        routePathKey={"adminPath"}
        path={"/organization/company-info"}
      />
    ),
    browserTitle: "Company Info",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/organization/company-info`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization Info",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Company Info", icon: CompanyIcon },
      portal: { name: "Company Info", icon: CompanyIcon },
    },
  },
  {
    path: `${adminPath}/organization/users`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization Users",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Users", icon: UsersIcon },
      portal: { name: "Users", icon: UsersIcon },
    },
  },
  {
    path: `${adminPath}/organization/settings`,
    component: BuyerAdminOrganization,
    browserTitle: "Organization settings",
    exact: true,
    layout: LayoutPortal,
    parentNav: "MY ORGANIZATION",
    nav: {
      admin: { name: "Settings", icon: SettingsIcon },
      portal: { name: "Settings", icon: SettingsIcon },
    },
  },
  {
    path: `${accountPath}/quotes`,
    component: pageForEdition({
      DefaultPage: BuyerQuotesList,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Quotes",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Quotes", icon: QuoteIcon },
      admin: { name: "Quotes", icon: QuoteIcon },
    },
  },
  {
    path: `${accountPath}/samples`,
    component: pageForEdition({
      DefaultPage: BuyerSampleRequests,
      StarterEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Requests",
    exact: true,
    layout: LayoutPortal,
    parentNav: "TRANSACTIONS",
    nav: {
      portal: { name: "Samples", icon: LabFlaskIcon },
      admin: { name: "Samples", icon: LabFlaskIcon },
    },
  },
  {
    path: `${accountPath}/samples/:sample_request_id`,
    component: pageForEdition({
      DefaultPage: BuyerSampleRequestDetail,
      StarterEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Sample Request",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${accountPath}/quotes/:quoteId`,
    component: pageForEdition({
      DefaultPage: BuyerQuoteDetail,
      StarterEditionPage: NotSupportedForEdition,
      PIMBasicEditionPage: NotSupportedForEdition,
    }),
    browserTitle: "Buyer Quote Detail",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${adminPath}/preferences`,
    component: UserPreferences,
    browserTitle: "Buyer Admin Preferences",
    exact: true,
    layout: LayoutPortal,
  },
  {
    path: `${storePath}/support`,
    component: SupportPage,
    exact: true,
    layout: LayoutPortal,
  },
];

/**
 * For react specific reasons the translation for public nav route text is in layout/shared/Nav.tsx.
 * See https://gitlab.agilis.dev/agilis/agilis3-frontend/merge_requests/808
 */
export const PublicRoutes: RouteType[] = [
  {
    path: `${storePath}/home`,
    component: Homepage,
    exact: true,
    layout: LayoutPublic,
    nav: {
      public: { name: "Home" },
    },
    internalName: "home",
    layoutProps: {
      fullWidth: true,
    },
  },
  {
    path: `${storePath}/join/:invite_id`,
    component: SetUpCompany,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/portfolio`,
    component: PublicIndexWrapper,
    exact: true,
    layout: LayoutPublic,
    internalName: "portfolio",
    nav: {
      public: { name: "Portfolio" },
    },
    layoutProps: {
      fullWidth: true,
    },
  },
  {
    path: `${storePath}/product/:productSlug`,
    component: PublicProductDetailPortfolio,
    exact: true,
    layout: LayoutPublic,
    layoutProps: {
      fullWidth: true,
    },
  },

  {
    path: `${storePath}/contact-us`,
    component: ContactUsPage,
    exact: true,
    layout: LayoutPublic,
    internalName: "contact_us",
    nav: { public: { name: "Contact Us" } },
  },
  {
    path: `${storePath}/contact-us/thank-you`,
    component: ThankYouPage,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/support`,
    component: SupportPage,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/register`,
    component: Registration,
    exact: true,
    internalName: "register",
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/register/thank-you`,
    component: ThankYouPage,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/login`,
    component: Login,
    exact: true,
    browserTitle: "Login",
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/manual_login`,
    component: Login,
    exact: true,
    browserTitle: "Manual Login",
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/two-factor-auth-login`,
    component: TwoFAPage,
    exact: true,
    browserTitle: "2FA Login",
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/unauthorized`,
    component: () => <UnauthorizedPage />,
    exact: true,
    browserTitle: "Access Denied",
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/forgot-password`,
    component: ForgotPassword,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/forgot-username`,
    component: ForgotUserName,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/activate-account/:token`,
    component: ActivateAccount,
    exact: true,
    browserTitle: "Account activation",
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/reset-password/:token`,
    component: ResetPassword,
    exact: true,
    browserTitle: "Reset Password",
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/cart`,
    component: CartSwitcherGuest,
    internalName: "portfolio",
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/cart/thank-you-quote`,
    component: ThankYouPage,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/cart/thank-you-sample`,
    component: ThankYouPage,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/404`,
    component: NotFoundPage,
    exact: true,
    layout: LayoutPublic,
  },
  {
    path: `${storePath}/auto-close-tab`,
    component: AutoCloseBrowserTab,
    exact: true,
    browserTitle: "Close Tab",
    layout: LayoutPublic,
    layoutProps: {
      omitHeader: true,
      omitUserArea: true,
    },
  },
];

export const Routes = memo(function Routes() {
  return <PageProvider AllowedRoutes={AllowedRoutes} />;
});
